import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import CookieConsent from './components/CookieConsent';
import BackToTop from './components/BackToTop';
import LoadingFallback from './components/LoadingFallback';
import './App.css';

// Code-split all pages for better performance
const Home                    = lazy(() => import('./pages/Home'));
const Services                = lazy(() => import('./pages/Services'));
const StaffAugmentation       = lazy(() => import('./pages/StaffAugmentation'));
const DedicatedTeams          = lazy(() => import('./pages/DedicatedTeams'));
const ManagedProjectDelivery  = lazy(() => import('./pages/ManagedProjectDelivery'));
const GovernmentSubcontracting = lazy(() => import('./pages/GovernmentSubcontracting'));
const Industries              = lazy(() => import('./pages/Industries'));
const About                   = lazy(() => import('./pages/About'));
const CaseStudies             = lazy(() => import('./pages/CaseStudies'));
const Insights                = lazy(() => import('./pages/Insights'));
const Contact                 = lazy(() => import('./pages/Contact'));
const Privacy                 = lazy(() => import('./pages/Privacy'));
const Terms                   = lazy(() => import('./pages/Terms'));
const Accessibility           = lazy(() => import('./pages/Accessibility'));
const NotFound                = lazy(() => import('./pages/NotFound'));

export default function App() {
  return (
    <Router>
      <ErrorBoundary>
        <ScrollToTop />
        <a href="#main-content" className="skip-nav">Skip to main content</a>
        <Navbar />
        <main id="main-content">
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/"                          element={<Home />} />
              <Route path="/services"                  element={<Services />} />
              <Route path="/staff-augmentation"         element={<StaffAugmentation />} />
              <Route path="/dedicated-teams"            element={<DedicatedTeams />} />
              <Route path="/managed-project-delivery"   element={<ManagedProjectDelivery />} />
              <Route path="/government-subcontracting"  element={<GovernmentSubcontracting />} />
              <Route path="/industries"                 element={<Industries />} />
              <Route path="/about"                      element={<About />} />
              <Route path="/case-studies"                element={<CaseStudies />} />
              <Route path="/insights"                   element={<Insights />} />
              <Route path="/contact"                    element={<Contact />} />
              <Route path="/privacy"                     element={<Privacy />} />
              <Route path="/terms"                       element={<Terms />} />
              <Route path="/accessibility"                element={<Accessibility />} />

              {/* Legacy URL redirects — preserve link equity from the previous site structure */}
              <Route path="/it-services" element={<Navigate to="/government-subcontracting" replace />} />
              <Route path="/our-work"    element={<Navigate to="/case-studies" replace />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <CookieConsent />
        <BackToTop />
      </ErrorBoundary>
    </Router>
  );
}
